import React from "react";
import { motion } from "framer-motion";
import { Check, Coins } from "lucide-react";

export default function RoyaltyPricing() {
  const scrollToForm = () => {
    const el = document.querySelector("#register");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      const sel = document.querySelector('[data-testid="form-request-type"]');
      if (sel) {
        sel.value = "royalty";
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }, 600);
  };

  const features = [
    "دریافت درآمد ارزی از پلتفرم‌ها",
    "تسویه در ایران با بالاترین نرخ ارز قابل پرداخت",
    "گزارش درآمد شفاف و قابل پیگیری",
    "مناسب برای موزیک و موزیک‌ویدیو",
    "بدون نیاز به حساب بانکی خارجی",
  ];

  return (
    <section id="royalty-pricing" className="py-20 md:py-28 relative">
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 mx-auto w-[36rem] h-[36rem] bg-cyan-500/10 blur-[160px] rounded-full pointer-events-none" />
      <div className="max-w-5xl mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="glass rounded-[2.5rem] p-8 md:p-12 relative overflow-hidden"
          data-testid="royalty-pricing-card"
        >
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-purple-600/15 blur-[120px] rounded-full pointer-events-none" />

          <div className="grid md:grid-cols-12 gap-8 items-center relative">
            <div className="md:col-span-7">
              <div className="inline-flex items-center gap-2 glass rounded-full px-4 py-1.5 text-xs text-slate-200 mb-5">
                <Coins className="w-3.5 h-3.5 text-cyan-300" />
                نقد کردن درآمد موسیقی
              </div>
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
                درآمد <span className="gradient-text-neon">ارزی</span> موزیکت را در ایران تسویه کن
              </h2>
              <p className="mt-4 text-slate-300 leading-relaxed">
                درآمد دریافتی از پلتفرم‌های بین‌المللی پس از کسر کارمزد، با بالاترین نرخ ارز قابل پرداخت در ایران تسویه می‌شود.
              </p>

              <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
                {features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-200">
                    <Check className="w-4 h-4 text-cyan-300 mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-5">
              <div className="glass rounded-3xl p-8 text-center border-purple-500/30">
                <div className="text-xs text-slate-400 mb-3">کارمزد نقد کردن درآمد</div>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-7xl font-black gradient-text-neon leading-none">۲۵</span>
                  <span className="text-4xl font-bold text-slate-200">٪</span>
                </div>
                <div className="mt-2 text-sm text-slate-400">از مبلغ درآمد دریافتی</div>
                <button
                  onClick={scrollToForm}
                  className="mt-7 w-full justify-center btn-primary"
                  data-testid="royalty-pricing-cta"
                >
                  درخواست نقد کردن درآمد
                </button>
                <p className="mt-4 text-[11px] text-slate-500 leading-relaxed">
                  درآمد قطعی قابل تضمین نیست و به عملکرد اثر در پلتفرم‌ها بستگی دارد.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
